import React from "react"

import {FieldConditionFormProps} from "./condition/@types"

export default function FieldFilterForm(props:FieldConditionFormProps):React.ReactElement {
    return <props.field.renderComponents.filterForm {...props} key={props.field.fieldId}/>
}